import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import {
  selectCurrentModDetails,
  selectEffectiveDateTypes,
  selectInsuranceTypes,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { useTranslation } from 'react-i18next';
import { insuranceModStyles } from './InsuranceMod.styles';
import { InsuranceType } from './InsuranceType';
import { EffectiveInsuranceType } from './EffectiveInsuranceType';
import { useFormContext, useWatch } from 'react-hook-form';
import { InsuranceCustomDate } from './InsuranceCustomDate';
import { InsuranceAmount } from './InsuranceAmount';

export const InsuranceMod = () => {
  const { t } = useTranslation();
  const { classes } = insuranceModStyles();
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const effectiveDateTypes = useSelector(selectEffectiveDateTypes);
  const insuranceTypes = useSelector(selectInsuranceTypes);
  const { getValues } = useFormContext();
  const isModEdit = useSelector(selectIsEditMod);
  const [selectedInsuranceType, setSelectedInsuranceType] = useState('');
  const selectedInsuranceValue = useWatch({ name: 'insuranceType' });
  const effectiveDateValue = useWatch<any>({ name: 'effectiveDateTypeId' });

  const handleInsuranceTypeChange = value => {
    setSelectedInsuranceType(value);
  };

  useEffect(() => {
    setSelectedInsuranceType(getValues('insuranceType'));
  }, []);

  return (
    <>
      <Grid height="370px">
        <Grid item xs={12}>
          <Typography component="span" className={classes.providerLb}>{`${t(
            'placement.placementMods.insuranceProvider',
          )}`}</Typography>
          <Typography component="span" sx={{ mr: '70px' }}>
            {selectedModsDetails?.insuranceProviderDescription}
          </Typography>
        </Grid>
        {insuranceTypes && (
          <Grid item xs={12} className={classes.gridRow}>
            <InsuranceType
              options={insuranceTypes}
              isModEdit={isModEdit}
              onInsuranceTypeChange={handleInsuranceTypeChange}
              setSelectedInsuranceType={setSelectedInsuranceType}
            />
          </Grid>
        )}
        {selectedInsuranceValue && selectedInsuranceType !== 'Standard' && (
          <Grid item xs={12} className={classes.gridRow}>
            <InsuranceAmount isModEdit={isModEdit} />
          </Grid>
        )}
        <Grid item xs={12} className={classes.gridRow}>
          <EffectiveInsuranceType options={effectiveDateTypes} isModEdit={isModEdit} />
        </Grid>

        {effectiveDateValue && parseInt(effectiveDateValue) !== 1 && (
          <Grid item xs={12} className={classes.gridRow}>
            <InsuranceCustomDate isModEdit={isModEdit} />
          </Grid>
        )}
      </Grid>
    </>
  );
};
